import loadable from '@loadable/component';

export default {
    seller_infos: loadable(() => import('./InfosSellerModule')),
    seller_alert_banner: loadable(() => import('./AlertBannerSellerModule')),
    seller_presentation: loadable(() => import('./PresentationSellerModule')),
    seller_banner: loadable(() => import('./BannerSellerModule')),
};
